export const initCategorySlider = function () {
    const slider = document.querySelector('.news-categories');
    let isDown = false;
    let startX;
    let scrollLeft;
    let hasMoved = false;

    // 1. Mouse Wheel Integration
    slider.addEventListener('wheel', (e) => {
        if (e.deltaY !== 0) {
            e.preventDefault();
            slider.scrollLeft += e.deltaY;
        }
    }, { passive: false });

    // 2. Drag Start
    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        hasMoved = false;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });

    // 3. Dragging
    slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;

        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; // Multiplier for speed

        if (Math.abs(x - startX) > 5) {
            console.log('hasMoved');

            hasMoved = true; // Mark as moved so we can block the click later
        }

        e.preventDefault();
        slider.scrollLeft = scrollLeft - walk;
    });

    // 4. Drag End
    slider.addEventListener('mouseup', () => {
        isDown = false;
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
    });

    // 5. Link Protection Logic
    slider.addEventListener('click', (e) => {
        if (hasMoved) {
            e.preventDefault(); // Don't follow link if the user was dragging
        }
    });
}